export default function () {
  this.loadUsers()
}
